import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, Subject } from 'rxjs';

import {
  SalvarInscricao,
  FiltroVagaDisponiveis,
  UnidadesFederativas,
  UnidadesOperacional,
  VagaDisponivelCadastroReserva,
  RetornoPadrao
} from '@app/models/sisrh.model';
import { AutenticacaoService } from '@app/services/autenticacao.service';
import { SisrhService } from '@app/services/sisrh.service';
import { ModalService } from '@app/shared/services/modal.service';
import situacaoInscricao from '@assets/json/situacao-inscricao.json';
import situacaoProcessoSeletivo from '@assets/json/situacao-processo-seletivo.json';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { IniciarRedacaoCommand, SalvarFotoCommand } from '@app/models/redacao';
import { finalize, retry } from 'rxjs/operators';
import { RedacaoService } from '@app/services/redacao.service';
import Swal from 'sweetalert2';
import { AceitarConviteCommand, RejeitarConviteCommand } from '@app/models/cadastroReserva';

@Component({
  templateUrl: './vaga-lista.page.html'
})
export class VagaListaPage implements OnInit, AfterViewInit {

  @ViewChild('modal', { static: false }) modal;
  @ViewChild('modalRedacao', { static: false }) modalRedacao;
  @ViewChild('modalRedacaoFoto', { static: false }) modalRedacaoFoto;
  @ViewChild('modalFoto', { static: false }) modalFoto;
  @ViewChild('modalFoto', { static: false }) botaoModalFoto;
  vagasDisponiveis: Observable<any>;
  situacaoInscricao = situacaoInscricao;
  situacaoProcessoSeletivo = situacaoProcessoSeletivo;
  enviando = false;
  cpfCandidato;
  idVagaModal: string;
  idRedacaoModal: string;
  idInscricaoModal: string;
  controleDeclaracao: FormControl;
  trigger: Subject<void> = new Subject<void>();
  cameraDisponivel = true;
  guidEmpty = '00000000-0000-0000-0000-000000000000';
  public formulario: FormGroup;
  listaUf: UnidadesFederativas[];
  exibirFiltroUnidadeOperacional = false;
  unidadesOperacional: UnidadesOperacional[];
  vagasCadastroReserva$: Observable<VagaDisponivelCadastroReserva[]>;
  abaAtiva: number;



  constructor(
    private autenticacaoService: AutenticacaoService,
    private router: Router,
    private sisrhService: SisrhService,
    private modalService: ModalService,
    public ngbModal: NgbModal,
    private redacaoService: RedacaoService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.listarUfs();

    this.controleDeclaracao = new FormControl();
    this.cpfCandidato = this.autenticacaoService.getValorUsuarioAtualCandidato.cpf;

    const [_, searchParams] = this.router.url.split('?');
    const query = new URLSearchParams(searchParams);

    if (query.get('fazerRedacao') != '1') {
      this.autenticacaoService.verificarTermoUsuario(this.autenticacaoService.getValorUsuarioAtualCandidato.cpf, 'PORTAL_CANDIDATO', 'TERMO_DADOS_PESSOAIS')
        .subscribe(
          result => {
            if (!result) {
              // const query = new URLSearchParams(this.router.url.split('?')[1]);
              this.router.navigate(['/termoUsuario'] /*, { queryParams: { urlRetorno: this.router.url, fazerRedacao: query.get('fazerRedacao') || '0' } }*/);
            }
          }
        );
    }

    localStorage.removeItem('idInscricao');

    this.configurarFormulario();

    const filtros: FiltroVagaDisponiveis = {
      idCandidato: this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato,
      uf: null,
      idUnidade: null,
      termo: null,
    };

    this.vagasDisponiveis = this.sisrhService
      .vagasDisponiveisPorCandidato(filtros);

    this.vagasCadastroReserva$ = this.sisrhService.BuscarVagasDisponiveisCadastroReserva(filtros);
  }

  ngAfterViewInit(): void {
    const idVaga = this.route.snapshot.queryParamMap.get('idVaga');
    const idInscricao = this.route.snapshot.queryParamMap.get('idInscricao');
    const fazerRedacao = this.route.snapshot.queryParamMap.get('fazerRedacao');

    this.sisrhService.BuscarDadosBasicosRedacaoPorInscricao(idInscricao).subscribe(res => {
      const redacao = res;

      // verificar se redacão foi concluída
      if (redacao && redacao.horarioInicio && redacao.horarioFinalizacao) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Esta redação já foi concluída!',
          allowOutsideClick: false,
          showConfirmButton: false
        });

        localStorage.removeItem('idInscricao');
        this.autenticacaoService.logout();
        this.router.navigate(['/login']);
      } else {
        let idRedacao = null;
        if (redacao) idRedacao = redacao.idRedacao;
        this.abrirModalRedacao(idVaga, idRedacao, idInscricao);
      }
    });
  }

  configurarFormulario() {
    this.formulario = new FormGroup({
      uf: new FormControl(null),
      idUnidade: new FormControl(null),
      termo: new FormControl(null),
    });

    this.verificarValorSelecionado();
  }

  verificarValorSelecionado() {
    this.formulario.get('uf').valueChanges.subscribe(valorSelecionado => {
      if (valorSelecionado) {
        this.exibirFiltroUnidadeOperacional = true;
        const ufSelecionada = this.formulario.get('uf').value;
        this.listarUnidadesOperacional(ufSelecionada);
      }
    });
  }

  pesquisar() {
    this.buscarVagasDisponiveis();
  }

  buscarVagasDisponiveis() {
    const filtros: FiltroVagaDisponiveis = {
      idCandidato: this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato,
      uf: this.formulario.get('uf').value ? this.formulario.get('uf').value : null,
      idUnidade: this.formulario.get('idUnidade').value ? this.formulario.get('idUnidade').value : null,
      termo: this.formulario.get('termo').value ? this.formulario.get('termo').value : null,
    };

    if (this.abaAtiva === 1) {
      this.vagasDisponiveis = this.sisrhService
        .vagasDisponiveisPorCandidato(filtros);
    } else {
      this.vagasCadastroReserva$ = this.sisrhService.BuscarVagasDisponiveisCadastroReserva(filtros);
    }

    this.formulario.get('uf').setValue(null);
    this.formulario.get('idUnidade').setValue(null);
    this.formulario.get('termo').setValue(null);

    this.exibirFiltroUnidadeOperacional = false;
  }

  corSituacao(inscricao) {

    if (inscricao === situacaoInscricao.NaoInscricao) {
      return 'badge-secondary';
    }

    switch (inscricao.idSituacao) {
      case situacaoInscricao.AprovadoAnaliseDocumental:
        return 'badge-success';
      case situacaoInscricao.ComprovantesEnviados:
        return 'badge-warning';
      case situacaoInscricao.InscricaoCancelada:
        return 'badge-danger';
      case situacaoInscricao.InscricaoIniciada:
        return 'badge-info';
      case situacaoInscricao.NotasLancadas:
        return 'badge-primary';
      case situacaoInscricao.ReprovadoAnaliseDocumental:
        return 'badge-danger';
    }

  }

  inscreverSe(vaga: any) {
    const idCandidato = this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato;
    this.idVagaModal = vaga.idVaga;

    this.modalService.confirm('a', 'Atenção', `Deseja realmente se inscrever para a vaga de ${vaga.cargo.trim()}?`)
      .subscribe(x => {
        if (x) {
          this.sisrhService.dadosObrigatoriosPreenchidos(idCandidato).subscribe(data => {
            if (data === true) {
              this.ngbModal.open(this.modal, { size: 'lg' });
            } else {
              this.modalService.alert('e', 'Campo Obrigatário',
                'Existem dados obrigatórios cadastrais não preenchidos. Favor editar seus dados antes de continuar.').subscribe();
            }
          });
        }
      }
      );
  }

  realizarInscricao() {
    this.ngbModal.dismissAll();

    this.enviando = true;
    const salvarInscricao: SalvarInscricao = {
      idCandidato: this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato,
      idVaga: this.idVagaModal
    };

    this.sisrhService.salvarInscricao(salvarInscricao)
      .subscribe(
        y => {
          localStorage.setItem('idInscricao', y.data.idInscricao);
          this.verificarSeFormacoesBaseDados();
        }, () => {
          this.modalService
            .alert('e', 'Erro', 'Ocorreu um erro. Tente novamente mais tarde.')
            .subscribe(() => this.enviando = false);
        }
      );
  }

  enviarComprovantes(idInscricao: string) {

    localStorage.setItem('idInscricao', idInscricao);
    this.verificarSeFormacoesBaseDados();

  }

  verificarSeFormacoesBaseDados() {

    this.sisrhService
      .curriculo('formacao', this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato)
      .subscribe(x => {
        if (x.length) {
          this.router.navigate(['/candidato/inscricao']);
        } else {
          this.modalService
            .alert('i', 'Atenção',
              'Antes de se candidatar a vaga você deve atualizar seu currículo. Clique o botão Ok para ser redirecionado para a tela do Currículo.')
            .subscribe(() => this.router.navigate(['/candidato/curriculo']));
        }
      });

  }

  podeFazerRedacao(vagaDisponivel: any) {
    if (vagaDisponivel.inscricao != null && vagaDisponivel.inscricao.idSituacao !== situacaoInscricao.NaoInscricao) {
      const agendamento = vagaDisponivel.agendamentoRedacao;

      if (agendamento === null || (vagaDisponivel.redacao !== null && vagaDisponivel.redacao.horarioFinalizacao !== null)) {
        return false;
      }

      const horarioAtual = new Date();
      const dataAgendamento = agendamento.dataAgendamento;
      const horarioInicioAgendamento = new Date(dataAgendamento.split('T')[0] + 'T' + agendamento.horarioInicial + '.00-0300');
      const horarioFinalizacaoAgendamento = new Date(dataAgendamento.split('T')[0] + 'T' + agendamento.horarioFinal + '.00-0300');

      return horarioAtual >= horarioInicioAgendamento && horarioAtual < horarioFinalizacaoAgendamento;
    }

    return false;
  }

  abrirModalRedacao(idVaga: string, idRedacao: string, idInscricao: string) {
    if (idRedacao !== null) {
      this.router.navigate(['/candidato/fazer-redacao'], { queryParams: { idVaga, idRedacao } });
    } else {
      this.idVagaModal = idVaga;
      this.idInscricaoModal = idInscricao;
      this.ngbModal.open(this.modalRedacao, { size: 'lg' });
    }
  }

  handleImage(webcamImage: WebcamImage): void {
    const command: SalvarFotoCommand = {
      idRedacao: this.idRedacaoModal,
      base64Imagem: webcamImage.imageAsBase64,
      descricao: 'Antes da prova'
    };

    this.redacaoService.salvarFoto(command).pipe(retry(3)).subscribe(_ => {
      this.ngbModal.dismissAll();
      this.router.navigate(['/candidato/fazer-redacao'], { queryParams: { idVaga: this.idVagaModal, idRedacao: this.idRedacaoModal } });
    });
  }

  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  mostrarModalFotoRedacao() {
    if (this.cameraDisponivel === false) {
      this.ngbModal.dismissAll();
      Swal.fire({
        icon: 'warning',
        title: 'Atenção!',
        text: 'Ocorreu algum problema ao acessar sua câmera. Habilite sua câmera, atualize a página e acesse  novamente o link da prova discursiva.',
      });

      return;
    }
    const command: IniciarRedacaoCommand = {
      idInscricao: this.idInscricaoModal,
      idVaga: this.idVagaModal,
    };

    this.redacaoService.iniciarRedacao(command).subscribe(result => {
      if (result.data && result.data.idRedacao && result.data.idRedacao !== this.guidEmpty) {
        this.idRedacaoModal = result.data.idRedacao;

        this.ngbModal.dismissAll();
        this.abrirModal(this.modalFoto.nativeElement);

      } else {
        Swal.fire({
          icon: 'error',
          title: 'Atenção!',
          text: 'Ocorreu algum erro ao iniciar a redação.',
        });
      }
    }, error => {
      Swal.fire({
        icon: 'error',
        title: 'Atenção!',
        text: 'Ocorreu algum erro ao iniciar a redação.',
      });
    });
  }

  triggerSnapshot(): void {
    this.trigger.next();
  }

  handleInitError(error: WebcamInitError) {
    this.cameraDisponivel = false;
    console.log(error);
  }

  fecharModal(modal: HTMLDivElement) {
    modal.className = 'modal hide';
  }

  abrirModal(modal: HTMLDivElement) {
    modal.className = 'modal show';
    modal.style.display = 'block';
  }

  iniciarRedacao() {
    this.fecharModal(this.modalFoto);
    this.ngbModal.dismissAll();
    this.triggerSnapshot();
    const modalBackdrop = document.querySelector('body > div.modal-backdrop');

    if (modalBackdrop) {
      modalBackdrop.remove();
    }
  }

  listarUfs() {
    this.sisrhService.BuscarUnidadesFederativas().subscribe(data => {
      this.listaUf = data;
    });
  }

  listarUnidadesOperacional(ufSelecionada) {
    this.sisrhService.BuscarUnidadesOperacional(ufSelecionada).subscribe(data => {
      this.unidadesOperacional = data;
    });
  }

  mostrarModalConvite(idConviteCadastroReserva: string) {
    this.modalService.confirm('a', 'Atenção', 'Deseja se candidatar a esta vaga?').subscribe(x => {
      if (x) {
        const command: AceitarConviteCommand = {
          idConviteCadastroReserva
        };

        this.sisrhService.AceitarConviteCadastroReserva(command).pipe(
          finalize(() => this.pesquisar())
        ).subscribe(this.tratarRetornoPadrao);
      } else {
        const command: RejeitarConviteCommand = {
          idConviteCadastroReserva
        };

        this.sisrhService.RejeitarConviteCadastroReserva(command).pipe(
          finalize(() => this.pesquisar())
        ).subscribe(this.tratarRetornoPadrao);
      }
    });
  }

  tratarRetornoPadrao(retorno: RetornoPadrao) {
    if (retorno.success) {
      Swal.fire({ icon: 'success', title: 'Atenção!', text: retorno.message });
    } else {
      if (retorno.message) {
        Swal.fire({ icon: 'error', title: 'Atenção!', text: retorno.message });

      } else {
        Swal.fire({
          icon: 'error', title: 'Atenção!', text: 'Ocorreu um erro, tente novamente.',
        });
      }
    }
  }

  conviteDentroDoPrazo(dataLimiteAceitacao: string) {
    const dataLimite = new Date(`${dataLimiteAceitacao.split('T')[0]}T23:59:59`);
    const dataAtual = new Date();

    return dataAtual <= dataLimite;
  }
}
